export default {
    TaskStatus: {

        Processing: {
            code: "0",
            desc: "进行中"
        },
        Done: {
            code: "1",
            desc: "已完成"
        },
        Exception: {
            code: "2",
            desc: "已逾期"
        },
        Closed: {
            code: "3",
            desc: "已关闭"
        }
    }
};